module.exports = __webpack_public_path__ + "img/electric.9afd1445.svg";